import axios from "axios";
import TokenValidate from "./TokenValidate";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { KEY_STORAGE } from "../utils/Constant";

//Request Interceptor
axios.interceptors.request.use(
  async (config) => {
    const { getItem } = useLocalStorage();
    if (config.url.includes("/login")) return config;
    if (config.url.includes("/refresh")) return config;

    try {
      await TokenValidate();
      config.headers["Authorization"] = `Bearer ${getItem(
        KEY_STORAGE.USER_TOKEN
      )}`;
      console.log(`Bearer ${getItem(KEY_STORAGE.USER_TOKEN)}`);
      if (config.headers["Content-Type"] !== "multipart/form-data") {
        config.headers["Content-Type"] = "application/json";
      }
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // const { getItem } = useLocalStorage();
    const request = error.config; //this is actual request that was sent, and error is received in response to that request
    if (error.response && error.response.status === 401 && !request._retry) {
      request._retry = true;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem(KEY_STORAGE.USER_TOKEN);
      axios.defaults.headers.common["Content-Type"] = "application/json";
      return axios(request);
    }
    return Promise.reject(error);
  }
);

export default axios;
